import { ReactNode } from "react";
import { RootLayout } from "@/components/layouts";
import { Sidebar } from "@/components/ui/sidebar";

/* Prop Types */
interface LayoutProps {
  children: ReactNode;
}

/*
 * HomeLayout component
 */
export const HomeLayout = ({ children }: LayoutProps) => {
  /* Render */
  return (
    <RootLayout>
      <div className="grow flex flex-row gap-11">
        {/* Sidebar */}
        <Sidebar />

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="w-full h-full flex flex-col gap-4">{children}</div>
        </div>
      </div>
    </RootLayout>
  );
};
